import { UserStatus } from 'api/models';
import { User } from 'api/notifications';

interface Props {
  user: User;
}

export const sortByUserStatus = (
  { user: userA }: Props,
  { user: userB }: Props,
): number => {
  if (
    userA.userStatus === UserStatus.Inactive &&
    [UserStatus.Active, UserStatus.Invited].includes(userB.userStatus)
  ) {
    return 1;
  }

  if (
    userB.userStatus === UserStatus.Inactive &&
    [UserStatus.Active, UserStatus.Invited].includes(userA.userStatus)
  ) {
    return -1;
  }

  return 0;
};
